import { render, staticRenderFns } from "./comment-total.vue?vue&type=template&id=1a9bdecf&scoped=true"
import script from "./comment-total.vue?vue&type=script&lang=js"
export * from "./comment-total.vue?vue&type=script&lang=js"
import style0 from "./comment-total.vue?vue&type=style&index=0&id=1a9bdecf&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_d79148f6156699cf80ef22aa45ce0a5c/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a9bdecf",
  null
  
)

export default component.exports